module.exports = __webpack_public_path__ + "img/logo-invoize-dark.a5a945e2.svg";